
<modal-window :mainWidth="12" :paddings="'p-4 pl-2'">
  <grid
    :data-items="result"
    :columns="columns"
    :style="{ height: '500px', maxHeight: '500px' }"
    :filterable="true"
    :filter="filter"
    @filterchange="filterChange"
    :cell-render="'cellTemplate'"
  >
    <template v-slot:customHeader></template>
    <template v-slot:cellTemplate="{ props }">
      <td v-if="props.field === 'isChecked'">
        <button
          v-if="mode === 'diversion'"
          class="btn btn-sm btn-success"
          @click="processFlight(props.dataItem.id)"
          v-b-tooltip.hover.left
          :title="'Choose Flight'"
        >
          <i class="fa fa-plus mr-2"></i>
          Choose
        </button>
        <div v-else>
          <button
            class="btn btn-sm btn-success"
            v-if="props.dataItem[props.field] === false"
            @click="processFlight(props.dataItem.id)"
            v-b-tooltip.hover.left
            :title="'Add Flight'"
          >
            <i class="fa fa-plus"></i>
          </button>
          <button
            class="btn btn-sm btn-danger"
            v-if="props.dataItem[props.field] === true"
            @click="processFlight(props.dataItem.id)"
            v-b-tooltip.hover.left
            :title="'Remove Flight'"
          >
            <i class="fa fa-minus"></i>
          </button>
        </div>
      </td>
      <td v-else-if="props.field === 'dateCalc'">
        <i class="far fa-clock"></i>
        {{ props.dataItem[props.field] | formatDate }}
      </td>
      <td v-else-if="props.field === 'stdCalc' || props.field === 'staCalc'">
        {{ props.dataItem[props.field] | formatDate('HH:mm') }}
      </td>
      <td v-else>
        {{ props.dataItem[props.field] }}
      </td>
    </template>

    <template v-slot:filterSlotTemplate="{ props }">
      <div>
        <board-item-date-picker
          :mode="'date'"
          :value="props.value ? props.value.toISOString() : null"
          @input="
            (ev) => {
              props.onChange({ operator: 'gte', field: props.field, value: new Date(ev), syntheticEvent: ev });
            }
          "
        ></board-item-date-picker>
      </div>
    </template>
  </grid>
  <hr />
  <div class="d-flex justify-content-end">
    <button class="btn btn-sm btn-success" @click="closeModal()">
      <i class="far fa-times"></i>
      Close
    </button>
  </div>
</modal-window>
